/**
 * @generated SignedSource<<17bd47d054dc3dbd66184595c8c855ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePaywallCheckerContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksPaywallPromiseContent">;
  readonly " $fragmentType": "articlePaywallCheckerContent";
};
export type articlePaywallCheckerContent$key = {
  readonly " $data"?: articlePaywallCheckerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePaywallCheckerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePaywallCheckerContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksPaywallPromiseContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "c3446533a6322377431905aa7549609d";

export default node;
